export default __webpack_public_path__ + "static/media/right-chevron.040a1245.svg";